import { Component, type ErrorInfo, type ReactNode } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, info: ErrorInfo): void {
    console.error('Unhandled error in link builder:', error, info.componentStack)
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="flex h-dvh items-center justify-center p-6">
          <div className="max-w-md space-y-3 rounded-lg border bg-card p-6 text-sm shadow-sm">
            <h1 className="text-base font-medium">Something went wrong</h1>
            <p className="text-muted-foreground">
              The link builder hit an unexpected error. Reload the page to try again. If
              the problem persists, contact your administrator.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-md border bg-background px-3 py-1.5 text-xs font-medium shadow-sm transition-colors hover:bg-muted/50"
            >
              Reload
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
